// extracted by mini-css-extract-plugin
export default {"accordion":"accordion_accordion__ohrAi","accordion__chevron-holder":"accordion_accordion__chevron-holder__61mzP","accordion__body":"accordion_accordion__body__3Sf-3"};